<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Agendamento de validação cadastral</div>
      <b-card class="card-calendario shadow-sm mb-2 bg-white rounded schedule-success">
        <b-alert v-model="showErro" variant="danger">{{mensagemErro}}</b-alert>

        <calendario :idRoom="$route.params.roomId"></calendario>
      </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";
import calendario from "./components/Calendario.vue";

export default {
  components: {
    cabecalho,
    calendario
  },
  data() {
    return {
      mensagemErro: null,
      showErro: false,
      loading: false,
      events: null,
      firstDay: null,
      lastDay: null,
      dataInicioFormatada: null,
      dataFimFormatada: null
    };
  },
  computed: {
    ar: function() {
            var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        var arAndCertificateParsed = JSON.parse(arAndCertificate);
        
        //just for modals
        document.body.style.setProperty('--main-color', arAndCertificateParsed.mainColor);

        return arAndCertificateParsed;
      }
      return null;
    }
  },
  created() {
    if (sessionStorage.getItem("token") == "") {
      this.$router.replace("/" + this.arName.toLowerCase());
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/Schedule.vue